/**
 * Centralized Inventory Status Constants
 *
 * These are the canonical values used by the API.
 * NEVER compare against display labels - always use these constants.
 *
 * Display labels should be retrieved via translation keys:
 * - t('inventory.outOfStock')
 * - t('inventory.stopSell')
 * - t('inventory.inStock')
 */

export const InventoryStatus = {
  OUT_OF_STOCK: 'OutOfStock',
  STOP_SELL: 'StopSell',
  IN_STOCK: 'InStock',
  LOW_STOCK: 'LowStock',
  AVAILABLE: 'Available'
} as const

export type InventoryStatusType = typeof InventoryStatus[keyof typeof InventoryStatus]

/**
 * Check if a product is unavailable for purchase
 * @param inventoryLevel The inventory level status
 * @param outOfStockVisible If true, overrides inventory checks and treats product as available
 */
export function isProductUnavailable(inventoryLevel: string | undefined | null, outOfStockVisible?: boolean): boolean {
  // If OutOfStockVisible is true, product is always available
  if (outOfStockVisible === true) return false

  if (!inventoryLevel) return true
  return inventoryLevel === InventoryStatus.OUT_OF_STOCK ||
         inventoryLevel === InventoryStatus.STOP_SELL
}

/**
 * Check if a product is available for purchase
 * @param inventoryLevel The inventory level status
 * @param outOfStockVisible If true, overrides inventory checks and treats product as available
 */
export function isProductAvailable(inventoryLevel: string | undefined | null, outOfStockVisible?: boolean): boolean {
  return !isProductUnavailable(inventoryLevel, outOfStockVisible)
}
